import { render, staticRenderFns } from "./DepotModal.vue?vue&type=template&id=07631d0c&scoped=true"
import script from "./DepotModal.vue?vue&type=script&lang=js"
export * from "./DepotModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@7.1.2_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07631d0c",
  null
  
)

export default component.exports